<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <b><trans-text i18nKey="ui[11][1]"/></b>
        </h3>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="offset-md-2 col-md-8 px-md-5">
          <!-- 入力フォーム -->
          <page-form></page-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from "page/partials/Payment/Complate/PageForm.vue"

  export default {
    name:"",
    components: {
      PageForm,
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Complete.vue?f6771448